import { useContext } from "react";

import { AppConfigContext } from "../../../../core/configuration/Configuration";
import { useAuthorizedFetch } from "../../../../core/data-access/useAuthorizedFetch";
import { CreateEntityResponse } from "../../common/CreateEntityResponse";
import { CreateManzanitaPresetRequest } from "./requests/CreateManzanitaPresetRequest";
import { EditManzanitaPresetRequest } from "./requests/EditManzanitaPresetRequest";
import { GetManzanitaPresetPreviewByIdResponse } from "./responses/GetManzanitaPresetPreviewByIdResponse";
import { GetManzanitaPresetsListResponse } from "./responses/GetManzanitaPresetsListResponse";
import { GetManzanitaPresetsLookupResponse } from "./responses/GetManzanitaPresetsLookupResponse";

export const useManzanitaPresetApi = () => {
    const appConfigContext = useContext(AppConfigContext);
    const baseUrl = `${appConfigContext.ordersConfig.apiUrl}/manzanita-presets`;

    const { httpGet, httpPost, httpPut } = useAuthorizedFetch();

    const getManzanitaPresetsLookup = async (): Promise<GetManzanitaPresetsLookupResponse> => {
        return httpGet<GetManzanitaPresetsLookupResponse>(`${baseUrl}/get-lookup`);
    };

    const getManzanitaPresetsList = async (): Promise<GetManzanitaPresetsListResponse> => {
        return httpGet<GetManzanitaPresetsListResponse>(`${baseUrl}/get-list`);
    };

    const getManzanitaPresetPreviewById = async (presetId: string): Promise<GetManzanitaPresetPreviewByIdResponse> => {
        return httpGet<GetManzanitaPresetPreviewByIdResponse>(`${baseUrl}/get-by-id`, { presetId });
    };

    const createManzanitaPreset = async (request: CreateManzanitaPresetRequest): Promise<CreateEntityResponse> => {
        return httpPost(`${baseUrl}/create`, request);
    };

    const editManzanitaPreset = async (request: EditManzanitaPresetRequest): Promise<void> => {
        return httpPut<void>(`${baseUrl}/edit`, request);
    };

    return {
        getManzanitaPresetsLookup,
        getManzanitaPresetsList,
        getManzanitaPresetPreviewById,
        createManzanitaPreset,
        editManzanitaPreset
    };
};
